export default {
  plan: 'Plan',
  continue: 'Continuer',
  docs: 'Docs',
  assistViaEmail: 'Nous serons ravis de vous aider par email.',
  sendFeedback: 'Veuillez envoyer vos questions et commentaires à',
  howDoISignUp: "Comment m'inscrire",
  requiredName: 'Le nom est un champ obligatoire',
  requiredEmail: "L'email est un champ obligatoire",
  requiredPassword: 'Le mot de passe est un champ obligatoire',
  invalidEmail: "L'email n'est pas valide",
  minLengthPassword: 'Le mot de passe doit contenir 8 lettres ou chiffres',
  invalidPassword:
    'Le mot de passe doit contenir une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial',
  getStartedWorkoutPlanEmailReminder:
    "Pour commencer, rendez-vous simplement sur la page web de Fit4Me et répondez à quelques questions rapides sur vos préférences en matière d'entraînement et de nutrition, vos objectifs et votre niveau général de fitness. Nous vous demanderons également votre email: assurez-vous de l'avoir correctement saisi. Une fois que nous aurons conçu un plan rien que pour vous, nous vous fournirons le lien de téléchargement de l'application afin que vous puissiez démarrer immédiatement.",
  howWillIReceiveMyCustomizedMealAndWorkoutPlan:
    "Comment recevrai-je mon plan de repas et d'entraînement personnalisé ?",
  appDownloadAndAccessInstructions:
    "Vous recevrez un lien de téléchargement unique qui vous dirigera vers l'App Store pour télécharger l'application. Une fois l'application installée sur votre téléphone, vous devrez vous connecter avec votre email. Vous aurez un accès illimité à toutes les fonctionnalités de l'application pendant la durée de votre période payante. Si vous rencontrez des difficultés pour télécharger ou accéder à l'application, veuillez nous contacter à",
  planReceiveTime: "Quand recevrai-je mon plan de repas et d'entraînement personnalisé ?",
  planGenerationDetails:
    "Nos algorithmes intelligents sont très précis et capables de personnaliser votre plan de fitness en fonction de vos besoins spécifiques. Le lien de téléchargement unique sera généré dès que votre paiement sera effectué. Le plan sera disponible dès que vous téléchargerez l'application à l'aide de votre lien unique.",
  freeTrialQuestion: 'Offrons-nous toujours des essais gratuits ?',
  freeTrialInfo:
    "Veuillez noter que si un essai gratuit est proposé, cela sera explicitement indiqué sur l'écran des prix avant le paiement. Dans le cas contraire, vous achèterez notre abonnement sans essai gratuit.",
  billingQuestion: 'Comment serez-vous facturé ?',
  billingInfo:
    "En général, nous proposons des abonnements à renouvellement automatique. Selon l'option choisie, votre abonnement sera renouvelé à la fin de chaque période.",
  cancelSubscriptionQuestion: 'Puis-je annuler mon abonnement ?',
  cancelSubscriptionInfo:
    "Votre abonnement se renouvelle automatiquement à la fin de chaque période jusqu'à ce que vous l'annuliez. Notez que la suppression de l'application n'annule pas votre abonnement. Vous pouvez annuler un essai ou un abonnement via les abonnements sur votre iPhone ou par email.",
  noAccessQuestion: "Je n'ai plus accès à mon abonnement, que s'est-il passé ?",
  noAccessInfo:
    "Nous proposons parfois des abonnements non renouvelables qui expirent après la période d'abonnement (1 mois, 3 mois ou 6 mois). Une fois votre abonnement expiré, vous perdez l'accès à l'application. Si vous souhaitez continuer à utiliser l'application après l'expiration de votre premier abonnement, vous pouvez la racheter dans l'application ou sur la page web de Fit4Me à tout moment.",
  loginLabel:
    'Connectez-vous avec votre e-mail pour accéder à votre plan personnel de perte de poids',
  email: 'Email',
  logIn: 'Connexion',
  name: 'Nom',
  gender: {
    label: 'Genre',
    male: 'masculin',
    female: 'féminin',
  },
  dateOfBirth: 'Date de naissance',
  units: {
    label: 'Unités',
    kg: 'kg',
    cm: 'cm',
    lbs: 'lb',
    in: 'in',
    m: 'm',
    ft: 'ft',
  },
  startWeight: 'Poids de départ',
  height: 'Taille',
  doubleCheckAndRetry: 'Veuillez vérifier et réessayer',
  wrongEmail: 'Oups, email incorrect',
  invalidEmailOrPassword: 'Oups, email ou mot de passe incorrect',
  avatar: 'avatar',
  Profile: 'Profil',
  Subscriptions: 'Abonnements',
  loader: 'chargement',
  billingPeriod: 'Période de facturation',
  subscriptionPrice: 'Prix de l’abonnement',
  subscriptionCanceled: 'Votre abonnement a été annulé.',
  noFutureCharges: 'Vous ne serez plus facturé.',
  fullAccessUntilExpires:
    'Vous aurez un accès complet à Fit4Me jusqu’à l’expiration de votre abonnement actuel.',
  opps: 'Oups ! <br/>Quelque chose a mal tourné.',
  contactUsEmail: 'Contactez-nous via <br/><a href="mailto:{{companyEmail}}">{{companyEmail}}</a>',
  ok: 'OK',
  tooExpensive: 'C’est trop cher',
  planNotSuitable: 'Le plan ne correspond pas à mes besoins',
  appQualityDisappointment: 'La qualité de l’application est décevante',
  notUsingButMayReturn:
    'Je n’utilise pas l’application pour le moment, mais je pourrais revenir plus tard',
  goalsAchieved: 'J’ai déjà atteint mes objectifs',
  technicalIssues: 'Il y a eu des problèmes techniques',
  planTooChallenging: 'Mon plan est trop difficile à suivre',
  avoidAutoRenewalFee: 'Je souhaite éviter les frais de renouvellement automatique',
  forgotPassword: 'Mot de passe oublié ?',
  resetPassword: 'Réinitialiser le mot de passe',
  labelForgot: 'Entrez votre email pour réinitialiser votre mot de passe',
  placeholderEmail: 'Entrez votre email',
  recoveryEmailSentAt: 'Email de récupération envoyé à',
  pleaseCheckYourInbox: 'Veuillez vérifier votre boîte de réception (et les spams)',
  sendAgain: 'renvoyer',
  changeEmail: 'changer d’email',
  checkingYouEmail: 'Vérification de votre e-mail',
  agreePrivacyPolicy:
    "En continuant, vous acceptez notre <privacy>Politique de confidentialité</privacy> et nos <terms>Conditions d'utilisation</terms>",
  emailLogin: 'Connexion par e-mail',
  loginToFit4Me: 'Connexion à Fit4Me',
  enter5DigitCode:
    'Entrez le code à 5 chiffres envoyé à votre adresse e-mail <bold>{{email}}</bold>',
  didNotReceiveTheCode: 'Vous n’avez pas reçu le code ?',
  resendCode: 'Renvoyer le code',
  contactSupport: 'Ou vous pouvez <bold>contacter notre support</bold>',
  codeResent: 'Code renvoyé ! Vous pouvez demander un autre code dans <bold>{{seconds}}s</bold>',
  emailDoesntMatch: 'Le code de connexion ne correspond pas',
  reCheck: 'Vérifiez le code ou demandez-en un nouveau.',
  payments: 'Paiements',
  manageSubscription: 'Gérer l’abonnement',
  activeBadge: 'Actif',
  paymentMethod: 'Mode de paiement',
  cancelSubscriptionReason: 'Pourquoi voulez-vous annuler ?',
  nextChargeDate: 'Prochaine date de prélèvement',
  lastChargeDate: 'Dernière date de prélèvement',
  accessUntil: 'Accès jusqu’au',
  renewSubscription: 'Renouveler l’abonnement',
  addPaymentMethod: 'Ajouter un mode de paiement',
  noPaymentTitle: 'Aucun mode de paiement',
  noPaymentDescription: 'Ajoutez un mode de paiement pour commencer votre abonnement',
  canceledStatus: 'Annulé',
  yourFeedbackMatters: 'Votre avis compte !',
  specialOffer: 'Veuillez patienter pendant que nous générons une offre spéciale.',
  limitedDeal: 'Offre limitée',
  offerSavings: 'Nous offrons 99 % d’économies pendant 6 semaines',
  keepWellness: 'Poursuivez votre parcours bien-être pour seulement 1 % du coût habituel !',
  dontMissChance:
    '{{name}}, ne manquez pas cette chance de continuer avec les conseils nutritionnels personnalisés de Simple. Après votre période d’économies de 3 mois, la facturation trimestrielle standard (79,20 $) reprendra automatiquement.',
  keepPremium: 'Conserver Premium',
  cancelSubscriptionBtn: 'Annuler l’abonnement',
  footerText:
    'N’oubliez pas : vous pouvez annuler à tout moment avant le 30 avril 2025 sans frais de renouvellement. Votre tarif réduit de 99 % s’applique pour toute la période de 12 semaines. Si vous choisissez de continuer, votre abonnement se renouvellera automatiquement au tarif trimestriel habituel de 79,20 $ après la période promotionnelle. Nous ne proposons pas de remboursement pour une période d’abonnement partiellement utilisée. Pour gérer ou annuler votre abonnement, rendez-vous simplement sur votre page de gestion d’abonnement.',
  prosList: {
    analyzed: 'Profil analysé',
    noChange: 'Aucun changement de votre cycle de facturation actuel',
    after: 'Après 12 semaines, votre abonnement est de 79,20 $ par trimestre.',
  },
  gotIt: 'Ok, compris',
  weCanceled: 'Nous avons annulé votre abonnement',
  yourSubscriptionIsCanceled:
    'Votre abonnement Fit4Me est désormais annulé. Aucun frais supplémentaire ne s’appliquera. Vous aurez toujours un accès complet jusqu’au',
  supportForEditional: 'pour plus d’informations',
  contact: 'Contactez-nous',
  id: 'ID',
  'My account': 'Mon compte',
  'My Subscriptions': 'Mes abonnements',
  Support: 'Support',
  FAQ: 'FAQ',
  'Cancel Subscription': 'Annuler l’abonnement',
  'Money-Back Policy': 'Politique de remboursement',
  'Privacy Policy': 'Politique de confidentialité',
  'Terms of Use': 'Conditions d’utilisation',
  'Meals Recommendations': 'Recommandations de repas',
  'Contact Us': 'Nous contacter',
}
